import { AccountDTO } from '../../api/useAccountsQuery';

export const isAggregatedLinkedAccount = (account: AccountDTO): boolean =>
  account.IsLinked && !account.IsOrion;

export const canEditAggregatedLinkedAccountDescriptionOnly = (
  account: AccountDTO | undefined,
  hasEditProfileAccess: boolean,
): boolean => {
  if (!account || hasEditProfileAccess) {
    return false;
  }

  return isAggregatedLinkedAccount(account);
};
